import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom"; // Import useParams
import axios from "axios";
import HeaderImage from "../main/details/headerImage/HeaderImage";
import "../../App.css";
import ListeningDetails from "../main/details/listeningDetails/ListeningDetails";
import Head from "../Global/Head";
import Footer from "../shared/footer/Footer";
import Header from "../Global/Header";
import { ToastContainer } from "react-toastify";
import DetailsPageSkeliton from "../main/detailsPageSkeliton/DetailsPageSkeliton";
import BookingConformModal from "../main/bookingConformModal";
import ShareModal from "../shared/shareModal/ShareModal";
import Error from "./404";
import { useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import LoginModal from "../main/loginModal/LoginModal";

const Details = ({ open }) => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [loginData, setLoginData] = useState(false);

  const accessToken = localStorage.getItem("@user");

  const navigate = useNavigate();

  // useEffect(() => {
  //   if (!accessToken) {
  //     navigate("/");
  //   }
  // }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://htprdapi.hightable.ai/tables/view`,
        {
          params: {
            id,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`, // Add the Bearer token here
          },
        }
      );
      setData(response.data.details);
      setLoginData(true);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };
  const fetchDatanotoken = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://htprdapi.hightable.ai/tables/view`,
        {
          params: {
            id,
          },
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${accessToken}`, // Add the Bearer token here
          },
        }
      );
      setData(response.data.details);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (accessToken) {
      fetchData();
    } else {
      fetchDatanotoken();
    }
  }, [id, accessToken]); // Fetch data whenever id changes

  const bookTable = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await axios.post(
        `https://htprdapi.hightable.ai/table-booking/book-table?access_token=${accessToken}`,
        { id }
      );
      //  setBookingResponse(response.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //  window.scrollTo(0, 0); // Scroll to the top
  // }, []); // Run on mount

  const [isVisible, setIsVisible] = useState(false);
  const [bookPage, setBookPage] = useState(false);
  const [topPosition, setTopPosition] = useState(50);

  useEffect(() => {
    let interval;
    const totalTime = 1500;
    const steps = 800;
    const intervalTime = totalTime / steps;
    const decrement = 1300 / steps;

    const increment = 1300 / steps;

    if (!isVisible) {
      interval = setInterval(() => {
        setTopPosition((prev) => {
          if (prev <= 0) {
            clearInterval(interval);
            return 0;
          }
          return prev - decrement;
        });
      }, intervalTime);
    }

    return () => clearInterval(interval);
  }, [isVisible]);

  const slideGoDown = () => {
    const totalTime = 1500; // Total animation time
    const steps = 800; // Number of steps
    const intervalTime = totalTime / steps; // Time per step
    const increment = 1300 / steps; // Position change per step

    let interval = setInterval(() => {
      setTopPosition((prev) => {
        if (prev >= 80) {
          clearInterval(interval); // Stop the interval
          setTimeout(() => setIsVisible(false), 0); // Change state after animation ends
          return 80; // Ensure it stops at the original position
        }
        return prev + increment; // Increment position to slide down
      });
    }, intervalTime);
  };

  const BlankModal = ({ isVisible, setIsVisible }) => {
    return (
      <div
        className={`fixed inset-0 z-[1000]  transition-opacity duration-300 ${
          isVisible ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
      >
        <div
          className="absolute inset-0 login-slide-up  bg-black"
          onClick={() => setIsVisible(false)}
        ></div>
        <div className="relative w-full h-screen">
          <div
            style={{ top: `${topPosition}%` }} // Dynamic top position
            className="absolute w-full h-screen transition-none"
          >
            <LoginModal
              setIsVisible={setIsVisible}
              slideGoDOwn={slideGoDown}
              setBookPage={setBookPage}
              bookPage={bookPage}
            />
          </div>
        </div>
      </div>
    );
  };

  if (loading) return <DetailsPageSkeliton />;

  return (
    <>
      <ToastContainer />
      <div className="hidden md:inline">
        {data && (
          <Helmet>
            <title>{data?.title}</title>
            <meta name="description" content={data?.description} />
            <meta property="og:title" content={data?.title} />
            <meta property="og:description" content={data?.description} />
            <meta
              property="og:image"
              content="https://kwad.in/hightable/img/hightableog.jpg"
            />
            <meta property="twitter:title" content={data?.title} />
            <meta property="twitter:description" content={data?.description} />
            <meta
              property="twitter:image"
              content="https://kwad.in/hightable/img/hightableog.jpg"
            />
            <meta property="og:type" content="website" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1"
            />
            <meta name="generator" content="Webflow" />
            <link href="https://fonts.googleapis.com" rel="preconnect" />
            <link
              href="https://fonts.gstatic.com"
              rel="preconnect"
              crossOrigin="anonymous"
            />
          </Helmet>
        )}

        <Header setIsVisible={setIsVisible} />
      </div>
      <BlankModal setIsVisible={setIsVisible} isVisible={isVisible} />
      {data?.status !== 3 || !data ? (
        <Error />
      ) : (
        <>
          <BookingConformModal
            data={data}
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            fetchData={fetchData}
            setIsShareModalOpen={setIsShareModalOpen}
          />
          <HeaderImage
            data={data}
            fetchData={fetchData}
            setIsShareModalOpen={setIsShareModalOpen}
            setIsVisible={setIsVisible}
          />
          <ListeningDetails
            setLoginModal={setIsVisible}
            data={data}
            setIsModalOpen={setIsModalOpen}
            open={open}
            setBookPage={setBookPage}
            bookPage={bookPage}
            loginData={loginData}
          />
          <ShareModal
            data={data}
            setIsModalOpen={setIsShareModalOpen}
            isShareModalOpen={isShareModalOpen}
          />
        </>
      )}

      <Footer />
    </>
  );
};

export default Details;
